import { render, staticRenderFns } from "./AllStock.vue?vue&type=template&id=56f7e440&scoped=true&"
import script from "./AllStock.vue?vue&type=script&lang=js&"
export * from "./AllStock.vue?vue&type=script&lang=js&"
import style0 from "./AllStock.vue?vue&type=style&index=0&id=56f7e440&prod&lang=scss&"
import style1 from "./AllStock.vue?vue&type=style&index=1&id=56f7e440&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f7e440",
  null
  
)

export default component.exports